import { useEffect, useState } from "react";
import AdminBoxConent from "../../components/admin/AdminBoxContent";
import Job from "../../models/job";
import jobService from "../../services/jobService";
import JobsTable from "../../components/jobs/JobsTable";
import OccurrenceType from "../../models/occurrenceType";

const JobsRecurring: React.FC = () => {
  const [jobs, setJobs] = useState<Job[]>([]);

  useEffect(() => {
    const init = async () => {
      const { data: allJobs } = await jobService.getJobs();

      const jobs = allJobs.filter(
        (j) => j.occurrenceType !== OccurrenceType.Once
      );
      setJobs(jobs);
    };

    init();
  }, []);

  return (
    <AdminBoxConent
      title="Recurring Jobs"
      hasAddNew={false}
      count={jobs.length}
      countType="jobs"
      hasCurrentOrganizationDropdown={false}
    >
      <JobsTable jobs={jobs} showRecurrentJobsInfo={true} />
    </AdminBoxConent>
  );
};

export default JobsRecurring;
